import React, { useState } from 'react';
import { Building2, Briefcase, Package, BarChart3, ShoppingCart } from 'lucide-react';
import { BackButton } from '../../../common/BackButton';
import { LegalEntitySection } from './LegalEntitySection';
import { DepartmentSection } from './DepartmentSection';
import { ProcurementItemsSection } from './ProcurementItemsSection';
import { ProcurementItemBalancesSection } from './ProcurementItemBalancesSection';

type TabId = 'legal-entities' | 'departments' | 'items' | 'balances';

interface BestillingssystemAdminMainProps {
  onBack?: () => void;
}

export const BestillingssystemAdminMain: React.FC<BestillingssystemAdminMainProps> = ({ onBack }) => {
  const [active, setActive] = useState<TabId>('legal-entities');

  const tabs = [
    { id: 'legal-entities' as TabId, label: 'Selskap', icon: Building2 },
    { id: 'departments' as TabId, label: 'Avdelinger', icon: Briefcase },
    { id: 'items' as TabId, label: 'Bestillingsvarer', icon: Package },
    { id: 'balances' as TabId, label: 'Saldo sentrallager', icon: BarChart3 },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white border-b border-gray-200 p-4">
        <div className="max-w-7xl mx-auto flex items-center gap-4">
          <BackButton onClick={onBack || (() => window.history.back())} />
          <ShoppingCart className="text-blue-600" size={28} />
          <div>
            <h1 className="text-2xl font-bold text-gray-800">Bestillingssystem – Administrasjon</h1>
            <p className="text-sm text-gray-600 mt-1">
              Vedlikehold masterdata for bestillingsmodulen
            </p>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-6">
          <div className="border-b border-gray-200">
            <nav className="flex flex-wrap -mb-px" aria-label="Tabs">
              {tabs.map((tab) => {
                const Icon = tab.icon;
                const isActive = active === tab.id;
                return (
                  <button
                    key={tab.id}
                    onClick={() => setActive(tab.id)}
                    className={`flex items-center gap-2 px-5 py-3 border-b-2 font-medium text-sm transition-colors ${
                      isActive
                        ? 'border-blue-600 text-blue-700 bg-blue-50'
                        : 'border-transparent text-gray-600 hover:text-gray-800 hover:bg-gray-50'
                    }`}
                  >
                    <Icon size={18} />
                    {tab.label}
                  </button>
                );
              })}
            </nav>
          </div>
        </div>

        {active === 'legal-entities' && <LegalEntitySection />}
        {active === 'departments' && <DepartmentSection />}
        {active === 'items' && <ProcurementItemsSection />}
        {active === 'balances' && <ProcurementItemBalancesSection />}
      </div>
    </div>
  );
};
